import { render, staticRenderFns } from "./NeumaticosEnMalEstado.vue?vue&type=template&id=2b968e61"
import script from "./NeumaticosEnMalEstado.vue?vue&type=script&lang=js"
export * from "./NeumaticosEnMalEstado.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports